// vendor
import * as THREE from "three";

export const getInverseSphere = (r:number = 0.5, ws:number = 64, hs:number = 32) => {
	const geometry = new THREE.SphereGeometry(r, ws, hs);
	geometry.scale(-1, 1, 1);
	geometry.rotateY(-90);
	return geometry;
};